<template>
	<div class="">
		<Header></Header>
		
		<h4>{{oonfooData.title}}</h4>
		<div class="lines"></div>
		<div class="infomsg">
			<span>
				<img src="../assets/fenzhan/biao.png" alt="">
			</span>

			<span>
			  {{oonfooData.ctime | dateFormat}}
			</span>
			<span>
				<img src="../assets/fenzhan/dizhi.png" alt="">
			</span>
				<span>{{oonfooData.siteName}}</span>
			<span>
				<img src="../assets/fenzhan/yj.png" alt="">
			</span>
			<span>
					{{oonfooData.browseNum}}
			</span>
		</div>
		<!--内容-->
		<div class="countent1">
				<p v-html='oonfooData.content'></p>
		</div>
	
		<!---->
		<div class="nextBtn w95">
			<p @click="upArticle(up.id)">上一篇</p>
			<div class="boxs"></div>
			<p  @click="downArticle(down.id)">下一篇</p>
		</div>
		<Fotter></Fotter>
	</div>
</template>

<script>
	import Header from "./Header.vue";
	import Fotter from "./Fotter.vue";
	import __Config from '../api/config';
	export default {
		name: 'Fenzhan',
		components: {
			Header,
			Fotter
		},
		data() {
			return {
              id: null,
			  oonfooData:[],
			  tags:[],
			  up:{},
			  down:{},
			}

		},
		methods: {
             getDetailinfo(){
                var that = this;
				this.$axios.get(__Config.api.getinfo,{
					params: {
					    id:this.id,
						siteCode:this.$store.state.treeData.code,
						siteId:this.$store.state.treeData.id
					}
				})
				.then(function (res) {
					that.oonfooData= res.data.data.articleManager;
					that.tags = res.data.data.tags;
					that.up = res.data.data.up;
					that.down = res.data.data.down;
					// console.log(res.data.data)
				})
				.catch(function (err) {
					console.log(err);
				});
		  },
		    upArticle(id){
			
				this.id= id;
				this.getDetailinfo();
			
		  },
		  downArticle(id){
			 
			    this.id= id;
				this.getDetailinfo();
				 
		  }
		},
		created(){
			this.id = localStorage.getItem("Calendarid");
		   this.getDetailinfo();
		}
	}
</script>

<style scoped>
	@import url("../assets/css/articleDetail.css");
</style>



// WEBPACK FOOTER //
// src/components/Calendar_detail.vue